import { Link, useLocation } from 'react-router-dom';

import { cn } from '@/utils';

const NavItem = ({
  icon,
  pathname,
  label,
  exact = false,
  NotificationComponent
}) => {
  const location = useLocation();

  let isActive = location.pathname.startsWith(pathname);
  if (exact) {
    isActive = location.pathname === pathname;
  }

  return (
    <Link to={pathname}>
      <div
        className={cn(
          'text-center flex flex-col items-center gap-1 nav-button text-muted-foreground relative',
          {
            'text-primary': isActive
          }
        )}
      >
        {icon}
        <span
          className={cn('text-xs text-muted-foreground', {
            'text-foreground': isActive
          })}
        >
          {label}
        </span>
        {NotificationComponent}
      </div>
    </Link>
  );
};

export default NavItem;
